<template>
  <div class="w100 serveCenterDetail-page" style="background: #F2F3F6">
    <div class="bg-w mc card-shadow serve-detail"  v-loading="loading">
      <div  class="mc" style="width: 1200px;padding-bottom: 70px">


        <div class="sernav">
          <div class="sernav-link"
               v-for="item in leftNavList"
               @click="goScroll(item.key)"
               :class="fixName == item.key ? 'active' : ''"
               >
               <div class="sernav-link-box">{{item.text}}</div>
          </div>

        </div>
        <div class="serve-name pt20 pb20" v-text="resData.serveName">

        </div>
        <div class="area">
          <div class="area-item">
            <div class="cl-f pb20 area-title">
                <div class="area-item-line">
                  <div class="area-item-title" id="lcxx">
                    流程详细
                  </div>
                </div>
            </div>
            <div class="area-content">
              <table border="1" cellspacing="0" style="width: 100%">
                <tbody>
                <tr>
                  <td>服务对象</td>
                  <td v-text="resData.serveName"></td>
                  <td>归属部门</td>
                  <td v-text="resData.belongDeptName"></td>
                  <td>联系人</td>
                  <td v-text="resData.contact"></td>
                </tr>
                <tr>
                  <td>审批人</td>
                  <td v-text="resData.checkUser"></td>
                  <td>办理时效</td>
                  <td>{{resData.periordValidateHours&&(resData.periordValidateHours+' 小时')}}</td>
                  <td>联系方式</td>
                  <td v-text="resData.contactMobile"></td>
                </tr>
                <tr>
                  <td>申请方式</td>
                  <td>{{resData.applyType | formatApplyType}}</td>
                  <td>申请条件</td>
                  <td v-text="resData.applyCondition"></td>
                  <td>监管部门</td>
                  <td v-text="resData.deptName"></td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="area-item">
            <div class="cl-f pb20 area-title">
              <div class="area-item-line">
                <div class="area-item-title" id="blfs">
                  办理方式
                </div>
              </div>
            </div>
            <div class="area-content" v-if="resData.applyType==1||resData.applyType==3">
              <div class="table-title">在线办理</div>
              <table border="1" cellspacing="0" style="width: 100%">
                <tbody>
                <tr>
                  <td class="m-w">办理时间</td>
                  <td v-text="onlineDesc.handleTime"></td>
                </tr>
                <tr>
                  <td class="m-w">办理地点</td>
                  <td>线上</td>
                </tr>
                <tr>
                  <td class="m-w">办理材料</td>
                  <td v-text="onlineDesc.handleDesc "></td>
                </tr>
                <tr>
                  <td class="m-w">收费方式</td>
                  <td v-text="onlineDesc.feeWay"></td>
                </tr>
                </tbody>
              </table>
            </div>
            <div class="area-content" v-if="resData.applyType==2||resData.applyType==3">
              <div class="table-title">线下办理</div>
              <table border="1" cellspacing="0" style="width: 100%">
                <tbody>
                <tr>
                  <td class="m-w">办理时间</td>
                  <td v-text="offlineDesc.handleTime"></td>
                </tr>
                <tr>
                  <td class="m-w">办理地点</td>
                  <td v-text="offlineDesc.place"></td>
                </tr>
                <tr>
                  <td class="m-w">办理材料</td>
                  <td v-text="offlineDesc.handleDesc"></td>
                </tr>
                <tr>
                  <td class="m-w">收费方式</td>
                  <td v-text="offlineDesc.feeWay"></td>
                </tr>
                </tbody>
              </table>
            </div>

          </div>
          <div class="area-item">
            <div class="cl-f pb20 area-title">
              <div class="area-item-line">
                <div class="area-item-title" id="blcl">
                  办理材料
                </div>
              </div>
            </div>
            <div class="area-content">
              <div class="file-list">
                <div class="file-list-item cl-f" v-for="item in lineFileList">
                  <div class="file-list-item-filename fl" >
                    <i class="el-icon-document"></i>
                    {{item.relatedFileName}}
                  </div>

                  <div class="file-list-item-download fr file-list-item-btn" @click="downLoadFile(item)">下载</div>
                  <div class="file-list-item-see fr file-list-item-btn"  @click="previewFileFn(item)">在线预览</div>

                </div>

              </div>
              <div v-if="lineFileList.length==0" class="no-data">无附件资料。</div>
            </div>

          </div>
          <div class="area-item">
            <div class="cl-f pb20 area-title">
              <div class="area-item-line">
                <div class="area-item-title" id="bllc">
                  办理流程
                </div>
              </div>
            </div>
            <div class="area-content">
              <div  class="process-img" :class="{'card-shadow':processImg}">
                <img  v-if="processImg" :src="processImg.fileUrl" />
                <div v-else class="no-data">无流程图</div>
              </div>

            </div>

          </div>
          <div class="area-item">
            <div class="cl-f pb20 area-title">
              <div class="area-item-line">
                <div class="area-item-title" id="sdyj">
                  设定依据
                </div>
              </div>
            </div>
            <div class="area-content">
              <table border="1" cellspacing="0" style="width: 100%" v-if="policy&&policy.length">
                <thead>
                <tr>
                  <th>法律规定名称</th>
                  <th>法规类型</th>
                  <th>条例</th>
                  <th>条款内容</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="pro in policy">
                  <td v-text="pro.name"></td>
                  <td>{{pro.type | policyTypeFilter}}</td>
                  <td v-text="pro.rules"></td>
                  <td>
                    <span @click="seePolicyContent(pro)"  class="policy-content">查看</span></td>
                </tr>
                </tbody>
              </table>
              <div v-if="(resData.policy ||[]).length==0" class="no-data">暂无数据。</div>

            </div>

          </div>
          <div class="area-item">
            <div class="cl-f pb20 area-title">
              <div class="area-item-line">
                <div class="area-item-title" id="zysx">
                  注意事项
                </div>
              </div>
            </div>
            <div class="area-content">
              <div class="area-content-attention " v-if="resData.attention" v-text="resData.attention">

              </div>

            </div>

          </div>
          <div class="area-item">
            <div class="cl-f pb20 area-title">
              <div class="area-item-line">
                <div class="area-item-title" id="cjwt">
                  常见问题
                </div>
              </div>
            </div>
            <div class="area-content">
              <div v-for="(item,index) in (resData.qaList ||[])" class="area-content-qa">
                <div class="area-content-qa-answer">{{(index+1)+'、'+item.question}}</div>
                <div class="area-content-qa-question">{{'答：'+item.answer}}</div>
              </div>
              <div v-if="(resData.qaList ||[]).length==0" class="no-data">暂无数据。</div>
            </div>

          </div>
          <div class="area-item">
            <div class="cl-f pb20 area-title">
              <div class="area-item-line">
                <div class="area-item-title" id="lyyhf">
                  留言与回复
                </div>
              </div>
            </div>
            <div class="area-content">
                 <div class="area-content-leave" v-for="(item,index) in messageList" >
                   <div class="area-content-leave-qu" v-text="item.createUser+'：'+item.content"></div>
                   <div class="area-content-leave-ask" v-for="pro in (item.answerList||[])">
                     <span>学校回复：</span>
                     {{pro.content}}
                   </div>
                   <div class="area-content-leave-ask" style="color: #ccc"
                        v-if="(item.answerList||[]).length==0">
                     待回复！
                   </div>

                 </div>
              <div v-if="messageList.length==0" class="no-data">暂无留言记录。</div>
            </div>

          </div>
          <div class="area-item">
            <div class="cl-f pb20 area-title">
              <div class="area-item-line">
                <div class="area-item-title" id="fwpj">
                  服务评价
                </div>
              </div>
            </div>
            <div class="area-content">
              <div class="area-content-est">

                <div class="area-content-est-1 area-content-est-item">
                  <div class="area-content-est-item-title">
                   评价次数
                  </div>
                  <div class="area-content-est-item-count">
                   <span class="area-content-est-item-count-amount" v-text="rationsStatistics.general||0"></span>
                    <span>次</span>
                  </div>

                </div>
                <div class="area-content-est-2 area-content-est-item">
                  <div class="area-content-est-item-title" >
                    好评次数
                  </div>
                  <div class="area-content-est-item-count">
                    <span class="area-content-est-item-count-amount" v-text="rationsStatistics.praise||0"></span>
                    <span>次</span>
                  </div>

                </div>
                <div class="area-content-est-3 area-content-est-item">
                  <div class="area-content-est-item-title">
                    办理时效
                  </div>
                  <div class="area-content-est-item-count">
                    <span class="area-content-est-item-count-amount"
                          v-if="resData.periordValidateHours"
                          v-text="resData.periordValidateHours"></span>
                    <span  v-if="resData.periordValidateHours">小时</span>
                    <span  v-if="!resData.periordValidateHours" class="bold"
                           style="display: inline-block;
                            font-size:18px;margin-left: 10px;margin-top:16px"
                    >无</span>
                  </div>

                </div>
                <div class="area-content-est-4 area-content-est-item">
                  <div class="area-content-est-item-title">
                    办理评分
                  </div>
                  <div class="area-content-est-item-count">
                    <span class="area-content-est-item-count-amount" v-text="Number(rationsStatistics.avgRations||0).toFixed(1)"></span>
                    <span>分</span>
                    <!--<el-rate-->
                            <!--v-model="rationsStatistics.avgRations||0"-->
                            <!--disabled-->
                            <!--disabled-void-color="#ccc"-->
                            <!--text-color="#ff9900">-->
                    <!--</el-rate>-->
                  </div>

                </div>

              </div>

            </div>

          </div>
        </div>
      </div>

    </div>
    <div class="foot-info">
      <div class="cl-f inner">
      <div class="foot-info-collect fl">
        <div >
          <i v-if="resData.tagType" class="el-icon-star-on" style="color: rgb(247, 186, 42)" @click="favorOrRecall(resData)"></i>
          <i v-if="!resData.tagType" class="el-icon-star-off" @click="favorOrRecall(resData)"></i>
        </div>
        <div>
          <span  v-if="!resData.tagType" @click="favorOrRecall(resData)">收藏</span>
          <span  v-if="resData.tagType" style="color: rgb(247, 186, 42)" @click="favorOrRecall(resData)">取消收藏</span>
        </div>
      </div>
      <div class="foot-info-wirte-msg fl">
        <div>
          <i @click="goAddLeave" class="el-icon-chat-dot-round"></i>
        </div>
        <div>
          <span @click="goAddLeave">留言</span>
        </div>
      </div>
      <div class="foot-info-handle fr pt10">
        <el-button type="primary" @click="HandleApply()" v-if="(resData.applyType==1||resData.applyType==3)">我要办理</el-button>
      </div>
      <div class="foot-info-start-count fr pt5" style="width: 200px">
        <el-rate
                v-model="rationsStatistics.avgRations||0"
                disabled
                disabled-void-color="#ccc"
                text-color="#ff9900">
        </el-rate>
        <div>{{Number(rationsStatistics.avgRations||0).toFixed(1)}}星服务</div>
      </div>
    </div>
    </div>
    <!-- 详情、新增 -->
    <AddLeave ref="addLeave" @saveSuccess="saveSuccess"/>
    <!--线上办理-->
    <IframeView ref="IframeView"></IframeView>
    <el-dialog
            :close-on-click-modal="false"
            title="条款内容"
            :visible.sync="policyShow"
            width="600px" >
      <div style="width: 100%; height: 100%;" class="ql-container ql-snow bor-none">
        <div class="policyShowContent ql-editor" v-html="policyShowContent"></div>

      </div>
    </el-dialog>
    <IframeView ref="IframeView"></IframeView>
  </div>
</template>

<script>
    import AddLeave from "@/views/management/advice/addLeave";
    import { getServeDetail} from '@/api/serveCenter/serveCenter';
    import { handleserveFileDownload} from '@/api/managementCenter/otherApi';
    import { favorOrRecall} from '@/api/serveCenter/serveCenter';
    import IframeView from "@/components/public/IframeView.vue";
    import { bpmnStartProcess} from '@/api/bpmnApi/bpmn';
    export default {
        name: "ServeCenterDetail",
        components: {AddLeave,IframeView},
        props: [],
        data() {
            return {
                loading:false,
                policyShow:false,
                policyShowContent:'',
                resData:{},
                onlineDesc:{},
                offlineDesc:{},
                lineFileList:[],
                processImg:{},
                messageList:[],
                rationsStatistics:{},
                policy:[],
                fixName:'',
                leftNavList:[
                        {
                            text:'流程信息',
                            key:'lcxx'
                        },
                        {
                            text:'办理方式',
                            key:'blfs'
                        },
                        {
                            text:'办理材料',
                            key:'blcl'
                        },
                        {
                            text:'办理流程',
                            key:'bllc'
                        },
                        {
                            text:'设定依据',
                            key:'sdyj'
                        },
                        {
                            text:'注意事项',
                            key:'zysx'
                        },
                        {
                            text:'常见问题',
                            key:'cjwt'
                        },
                        {
                            text:'留言与回复',
                            key:'lyyhf'
                        },
                        {
                            text:'服务评价',
                            key:'fwpj'
                        }
                ]
            };
        },
        computed: {},
        created() {},
        mounted() {
            this.getServeDetailFn()
        },
        methods: {
            HandleApply(){
                let processDefId=this.resData.processDefId;
                bpmnStartProcess({processDefId}).then(({data})=>{
                    if(data.code==0){
                        this.$refs.IframeView.showView(data.data.url, data.data.taskInstId);
                    }else{
                        this.$message.warning(data.msg||'流程系统业务忙，请刷新或者重新操作');
                    }

                }).catch(err=>{
                    this.$message.error("服务异常" );
                })

            },
            favorOrRecall(item){
                const params={
                    isFavor:!item.tagType?true:false,
                    serveId:item.serveId
                }
                this.loading = true;
                favorOrRecall(params).then(({data})=>{
                    this.loading = false;
                    if(data.code == 0){
                        this.$message.success( !item.tagType?"收藏成功!" :"取消收藏成功!");
                        item.tagType=item.tagType?null:true;
                    }else{
                        this.$message.warning( data.msg||"操作失败!" );
                    }


                }).catch(err=>{
                    this.loading = false;
                })


            },
            goScroll(idName) {
                window.scrollTo(0, document.getElementById(idName).offsetTop-180 );
                setTimeout(() => {
                    this.fixName = idName;
                }, 200);
            },
            initLeftNavBar() {
                const scrollTop = document.documentElement.scrollTop;
                this.leftNavList.forEach((item,index)=>{
                    let offsetop =  document.getElementById(item.key).offsetTop
                    if(index=this.leftNavList.length-1){
                        if(offsetop-180<scrollTop){
                            this.fixName = item.key;
                            return
                        }

                    }else{
                        if(index==0){
                            let offsetopNext =  document.getElementById(this.leftNavList[index+1].key).offsetTop
                            if(0<scrollTop&&scrollTop<offsetopNext-185){
                                this.fixName = item.key;
                                return
                            }

                        }else{
                            let offsetopNext =  document.getElementById(this.leftNavList[index+1].key).offsetTop
                            if(offsetop-185<scrollTop&&scrollTop<offsetopNext-185){
                                this.fixName = item.key;
                                return
                            }
                        }



                    }

                })

            },
            getServeDetailFn(){
                this.loading = true;
                getServeDetail(this.$route.query.id).then(({data})=>{
                    this.loading = false;
                    if(data.code == 0){
                        this.resData = data.data ||{};
                        //手机号脱敏处理
                        var pat = /(\d{3})\d*(\d{4})/;
                        this.resData.contactMobile = this.resData.contactMobile.replace(pat,'$1****$2')
                        this.onlineDesc=JSON.parse(this.resData.onlineDesc);
                        this.offlineDesc=JSON.parse(this.resData.offlineDesc);

                        this.lineFileList=this.getlineFileList(this.resData.fileList);
                        this.policy=this.resData.policy?JSON.parse(this.resData.policy):[];
                        this.processImg=(this.resData.fileList||[]).find(i=>i.fileType=="1");
                        this.rationsStatistics= this.resData.rationsStatistics || {};

                        this.messageList=(this.resData.messageList || []).filter(i=>i.privateFlag==1);

                        this.$nextTick(() => {
                            window.addEventListener("scroll", this.initLeftNavBar);
                            this.initLeftNavBar();
                        });
                    }else{
                        this.$message.warning( data.msg||"获取服务信息失败！" );
                    }
                }).catch(err=>{
                    this.loading = false;
                })

            },
            goAddLeave(){
                this.$refs.addLeave.dialogShow(this.$route.query.id,this.resData.serveName);
            },
            saveSuccess(){
                this.getServeDetailFn();
            },
            downLoadFile(item){
                this.$DownLoad(
                    handleserveFileDownload(item.fileId),
                    null,
                    res => {
                        if (res.status == 200) {
                        } else {
                            this.$alert("下载出错,请稍后重试", "提示", {
                                confirmButtonText: "确定",
                                type: "warning"
                            });
                        }
                    },
                    error => {
                        this.$alert(error, "提示", {
                            confirmButtonText: "确定",
                            type: "warning"
                        });
                    }
                );
            },
          downloadImg(url){
              let a = document.createElement('a');
              let event = new MouseEvent('click')
              a.href = url;
              a.dispatchEvent(event)
          },
            getlineFileList(arr){
                let list =arr||[]
                let filtlist =  list.filter(item=>{
                    return item.fileType =='3'|| item.fileType =='4'
                });
                return filtlist
            },
            seePolicyContent(pro){
                this.policyShow=true;
                this.policyShowContent=pro.content;
            },
            previewFileFn(item){
                let routeData = this.$router.resolve({
                    name:"/previewFilePage",
                    query: {fileUrl:item.fileUrl}
                });
                window.open(routeData.href);

            }
        },
        destroyed() {
            window.removeEventListener("scroll", this.initLeftNavBar);
        },
        watch: {},
        filters: {
            formatApplyType(val){
             let obj= {
                 "1":"线上",
                 "2":"线上",
                 "3":"线上和线下"
                }
                return obj[val+'']
            },
            policyTypeFilter(val){
              let policyType=[
                  {
                      name:'请选择',
                      value:''
                  },
                  {
                      name:'国家法规',
                      value:'1'
                  },
                  {
                      name:'地方法规',
                      value:'2'
                  },
                  {
                      name:'行政法规',
                      value:'3'
                  },
                  {
                      name:'学校政策',
                      value:'4'
                  },
                  {
                      name:'部门规章',
                      value:'5'
                  },
                  {
                      name:'其他',
                      value:'6'
                  }
              ];
              let  obj =  policyType.find(i=>(val==i.value));
              if(obj){
                  return  obj.name;
              }else{
                  return '';
              }

        }
        },
    };
</script>

<style scoped lang="less" >
  div.ql-container{
    min-height: 0px!important;

  }
  div.ql-editor{
    padding: 0px!important;
  }
.policyShowContent{
  min-height: 300px;
  width: 100%;
  max-height: 500px;
  overflow-y: auto;
  /deep/img{
    max-width: 100%!important;
  }
}
  .serve-detail{
  .serve-name{
    font-size: 30px;
    font-family: PingFang SC;
    font-weight: bold;
    color: #1C1C1C;
  }

  .sernav{
    width: 150px;
    padding-left: 10px;
    position: fixed;
    left: calc(50vw - 640px);
    border-right: 1px solid #F1F3F4;
    top:180px;
    font-size: 16px;
    /*background: rgba(222, 225, 230,0.2);*/
    border-radius: 4px;
    &-link{
      position: relative;
      height: 40px;
      line-height: 40px;
      text-align: right;
      padding-right: 12px;
      cursor: pointer;
      // &.active{
      //   color: #064576;
      //   font-weight: bold;
      //   &:after{
      //     content: '';
      //     display: block;
      //     width: 3px;
      //     height: 3px;
      //     border-radius: 3px;
      //     background: #064576;
      //     position: absolute;
      //     right: -3px;
      //     top:20px
      //   }
      // }
      &:hover{
        color: #064576;
        font-weight: bold;
      }
    }

  }
.area{
  padding-left: 120px;
  &-item{
    padding: 20px;
    width: 100%;
    // &-title{
    //   border-bottom: 2px solid #234C6D;
    //   font-size: 22px;
    //   width: 115px;
    //   float: left;
    //   height: 40px;
    //   line-height: 40px;
    //   color: #064576;;
    // }
    // &-line{
    //   border-bottom: 1px solid #F1F3F4;
    //   font-size: 16px;
    //   height: 40px;
    //   width:calc(100% - 120px) ;
    //   float: left;
    // }
  }
  &-content{
    &-leave{
      padding: 10px 0;
      &-qu{
        font-size: 15px;
        font-family: PingFang SC;
        font-weight: 700;
        color: #2A84DC;
        line-height: 30px;
      }
      &-ask{
        span{
          color: #2A84DC ;
        }
        font-size: 13px;
        padding: 10px 10px ;
        background: #F7F7F7;
      }

    }

    &-est{
      background: #F7F7F7;
      height: 143px;
      padding-top: 35px;
      &-item{
       float: left;
        width: 25%;
        border-left: 1px solid #DEE1E6;
        height: 70px;
        padding-left: 30px;
        font-size: 16px;
        &-count{
          padding-top: 10px;
          span{
            font-size: 16px;
          }
          &-amount{
            font-size: 40px!important;
            display: inline-block;
            padding-right: 5px;
            font-weight: bold;
          }

        }
      }
      &-1{
        border-left: none;

      }
    }
    &-qa{
      padding: 6px 0;
      &-answer{
        font-family: PingFang SC;
        font-weight: 700;
        padding: 3px 0;
        color: #2A84DC;
        font-size: 15px;
      }
      &-question{
        padding: 3px 0;
        font-size: 13px;


      }
    }
    &-attention{
      padding: 20px 20px;
      font-size: 18px;
      text-indent:36px;
      background: #F7F7F7;
      color: #666666;
    }
    .file-list{
      &-item{
        padding: 6px 0;
        &-filename{
          font-size: 20px;
        }
        &-btn{
          width: 80px;
          height: 30px;
          background: #48A4EF;
          line-height: 30px;
          margin: 0 3px;
          text-align: center;
          color: #fff;
          border-radius: 4px;
          cursor: pointer;
        }
      }
    }
    .table-title{
      height: 40px;
      line-height: 40px;
      text-align: center;
      font-size: 20px;
      font-family: PingFang SC;
      font-weight: 500;
      color: #064576;
    }
    .process-img{
      width: 100%;
      text-align: center;
      img{
        max-width: 100%;
        vertical-align: top;
      }
    }
    table {
      // border:1px solid #B3CEE4;
      margin-bottom: 10px;
      tr {
      height: 32px;
        th{
          font-weight: bold;
          color: #064576;
        }

      td {
       >span {
         &.policy-content{
           color: #2A84DC;
           cursor: pointer;
           &:hover{
             font-weight: bold;
           }
         }
        }
        text-align: center;
        min-width: 80px;
        // &:nth-child(odd){
        //   background: #E8F2FA;
        // }
        &.m-w{
          width: 180px;
        }

      }
    }
    }

  }
}
}
  .foot-info{
    height: 70px;
    // background: #1E5783;
    width: 100%;
    color: #fff;
    position: fixed;
    bottom: 0;
    left: 0;
    .inner{
      width: 700px;
      padding-top: 10px;
      margin: 0 auto;
      i{
        font-size: 28px;
        cursor: pointer;
      }
      span{
        cursor: pointer;
      }
      >div{
        width: 100px;
        text-align: center;
      }
    }
  }
</style>
